module.exports = __webpack_public_path__ + "assets/img/Summary-item-head-bottom.b2eff538.png";